// Translate every string inside a plain object/array with t().
export default function tDeep(value, t) {
  if (typeof value === 'string') return t(value);
  if (Array.isArray(value)) return value.map((v) => tDeep(v, t));
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, typeof v === 'function' ? v : tDeep(v, t)]));
  }
  return value;
}